import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { Rs005SourceItemComponent } from 'src/app/shared/rs005-source-item/rs005-source-item.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-II',
    templateUrl: './rs005-card-II.component.html'
})

export class Rs005CardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public readOnlyGranacao?: boolean;
    public isSourceEnable: boolean = false;
    public dataHoraSecagem: any;
    public pesoPosSecagem: number = 0;
    public listOutrasSementes?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listResselecao?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();


    @ViewChild("viewContainerRef", { read: ViewContainerRef })
    VCR: ViewContainerRef;


    @Output() objMakeCalculations = new EventEmitter();
    @Output() changeCaixaPosMesaEvent = new EventEmitter();
    @Output() calcDatesDateEvent = new EventEmitter();

    child_unique_key: number = -1;

    sourceItemReferences = Array<ComponentRef<Rs005SourceItemComponent>>()

    public disabledBtnRemove: boolean = true;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, private CFR: ComponentFactoryResolver) {
        super('Avaliação de Granação', false);
        if (this.isBasica || this.isComercial) {
            this.formulario = this.formBuilder.group({
                Total_espigas_granacao: [null, []],
                Granacao_100: [null, []],
                Granacao_75: [null, []],
                Granacao_50: [null, []],
                Granacao_25: [null, []],
                Granacao_0: [null, []],
                Granacao_media: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                inicio_selecao_data: [null, [Validators.required, Validators.pattern(this.regexDate)]],
                inicio_selecao_hora: [null, [Validators.required, Validators.pattern(this.regexHour)]],
                peso_espigas_atipicas_kg: [null, [Validators.required]],
                peso_espigas_fora_do_padrao_kg: [null, [Validators.required]],
                fim_selecao_data: [null, [Validators.required, Validators.pattern(this.regexDate)]],
                fim_selecao_hora: [null, [Validators.required, Validators.pattern(this.regexHour)]],
                espigas_atipicas_prc: [null, [Validators.required]],
                presenca_outras_sementes: [null, [Validators.required]],
                motivo_parada_resselecao: [null, []],
                tempo_parada_selecao_hora: [null, [Validators.required]],
                caixa_pos_mesa: [null, [Validators.required]],
                peso_descarte_mesa_selecao_kg: [null, [Validators.required]],
                peso_pos_mesa: [null, [Validators.required]],
                resselecao: [null, [Validators.required]],
                desgrana_mesa: [null, []]
            });
            this.step = 'ETAPA 2 (Seleção)'
        }

    }

    async ngOnInit(): Promise<void> {
        this.readOnlyGranacao = false;
        await Promise.all([this.getListOutroasSementes(), this.getListResselecao()]);
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    validDates($event) {
        if (this.formulario?.get('inicio_selecao_data').value &&
            this.formulario?.get('inicio_selecao_hora').value) {
            var dateInit = this.generalService.createDateTimeData(this.formulario?.get('inicio_selecao_data').value, this.formulario?.get('inicio_selecao_hora').value);
            if (this.dataHoraSecagem >= dateInit) {
                this.formulario?.get('inicio_selecao_data').setErrors({ error: true })
                this.formulario?.get('inicio_selecao_hora').setErrors({ error: true })
            }
            else {
                this.formulario?.get('inicio_selecao_data').setErrors(null)
                this.formulario?.get('inicio_selecao_hora').setErrors(null)
            }

            if (this.formulario?.get('fim_selecao_data').value &&
                this.formulario?.get('fim_selecao_hora').value) {
                var dateEnd = this.generalService.createDateTimeData(this.formulario?.get('fim_selecao_data').value, this.formulario?.get('fim_selecao_hora').value);
                if (dateInit > dateEnd) {
                    this.formulario?.get('fim_selecao_data').setErrors({ error: true })
                    this.formulario?.get('fim_selecao_hora').setErrors({ error: true })
                }
                else {
                    this.formulario?.get('fim_selecao_data').setErrors(null)
                    this.formulario?.get('fim_selecao_hora').setErrors(null)
                }
            }
        }
        this.calcDatesDateEvent.emit();
    }

    makeCalc($event): void {
        const pesoEspigasAtipicasKg = Number(this.formulario?.get('peso_espigas_atipicas_kg').value) || 0
        if (this.pesoPosSecagem !== 0 && pesoEspigasAtipicasKg != null) {
            this.formulario?.get('espigas_atipicas_prc').setValue(pesoEspigasAtipicasKg * 100 / this.pesoPosSecagem);
        }
        else {
            this.formulario?.get('espigas_atipicas_prc').setValue(null);

        }
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getListOutroasSementes(): Promise<void> {
        const site: string = this.generalService.getLocalStorageDataSite();
        await this.formularioService
            .getListDropDownList('cd003', 'presenca_outras_sementes_especies')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listOutrasSementes = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    async getListResselecao(): Promise<void> {
        const site: string = this.generalService.getLocalStorageDataSite();
        await this.formularioService
            .getListDropDownList('rs005', 'resselecao')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listResselecao = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    changeCaixaPosMesa($event) {
        this.changeCaixaPosMesaEvent.emit();
    }

    addItem() {
        this.disabledBtnRemove = false;

        this.createSourceItemComponent();
    }

    public createSourceItemComponent() {
        let componentFactory = this.CFR.resolveComponentFactory(Rs005SourceItemComponent);
        let childComponentRef = this.VCR.createComponent(componentFactory);

        childComponentRef.instance.componentsReferences = this.sourceItemReferences;
        let childComponent = childComponentRef.instance;
        childComponent.unique_key = ++this.child_unique_key;
        childComponent.parentRef = this;

        this.sourceItemReferences.push(childComponentRef);
    }


    public async removeItem(): Promise<void> {
        if (!!this.sourceItemReferences) {
            this.sourceItemReferences[this.sourceItemReferences.length - 1].instance.remove(true);
            if (this.sourceItemReferences.filter(x => x.instance.btnExcluir == false).length == 0) {
                this.disabledBtnRemove = true
            }

        }
    }

    public removeSecagemItemComponent(key: number, lastItem = false) {
        this.VCR.remove(lastItem ? this.VCR.length - 1 : key);
        this.sourceItemReferences = this.sourceItemReferences.filter(
            x => x.instance.unique_key !== key)
        this.sourceItemReferences.forEach((x, index) => {
            x.instance.unique_key = index
        })
        --this.child_unique_key;
    }
}
